import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'

import smoothscroll from 'smoothscroll-polyfill'

import { Reveal } from 'components/Reveal'
import { BaseImage } from 'components/BaseImage'
import { useRef } from 'react'
// kick off the polyfill!
smoothscroll.polyfill()

const debug = window.document.title === 'TA-Interaktiv Microfrontend'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const lupeContainerRef = useRef<HTMLDivElement>(null)

  var part = properties?.part || '1'
  return (
    <AppContainer $colorMode={colorMode}>
      {(part === '1' || debug) && (
        <>
          <Reveal
            colorMode={colorMode}
            images={[
              require('../../images/deckblatt_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/deckblatt_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <>
                <TextWidthExtended>
                  <BaseImage
                    img={require('../../images/villa_1.jpg')}
                    source='Bild: Alexander Troehler/ Amt für Hochbauten'
                    title='Ein verwunschenes Gebäude in einem idyllischen Park. Hier hielt Hitler seine Zürcher Rede.'
                  />
                </TextWidthExtended>
                <TextWidth>
                  <p>
                    <h4>Geldnöte wegen Inflation</h4>
                    Im August vor hundert Jahren ist der grösste Verbrecher der
                    Menschheitsgeschichte erstmals – und letztmals – in die
                    Schweiz gereist. Jahrzehnte danach wird eine rätselhafte
                    Mitschrift seines in der Villa Schönberg gehaltenen Vortrags
                    auftauchen – aber davon später mehr.
                  </p>
                  <p>
                    Das Ziel von Hitlers Reise ist klar: Der damals 34-Jährige
                    will Geld für die NSDAP sammeln, die sich in finanziellen
                    Nöten befindet, nicht zuletzt wegen der in Deutschland
                    galoppierenden Inflation. Wenige Wochen nach seinem
                    Aufenthalt in der Schweiz wird Hitler vergeblich versuchen,
                    sich an die Macht zu putschen.
                  </p>
                  <p>
                    Die Rekonstruktion des Hitler-Besuchs zeigt auch, dass die
                    Schweizer Behörden schon zuvor auf den braunen Agitator
                    aufmerksam geworden sind. Das geht aus Hitlers Schweizer
                    Akte hervor, die wir im Bundesarchiv in Bern konsultiert
                    haben und hier veröffentlichen.
                  </p>
                </TextWidth>
              </>
            }
          />
          <Reveal
            cover
            colorMode={colorMode}
            images={[
              require('../../images/13nov_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/13nov_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <>
                <TextWidth>
                  <h4>Schweizer Informanten vom «Volksredner» beeindruckt</h4>
                  <p>
                    Den Schweizer Behörden ist Hitler demnach seit zwei Jahren
                    als «Vertreter der nationalsozialistischen deutschen
                    Arbeiterpartei» bekannt. Auf dem Deckblatt des
                    Hitler-Dossiers kleben zwei Fotos des Politikers sowie eine
                    Zeichnung aus einer Publikation der italienischen
                    Sozialisten, die Hitler als «Kopf der deutschen Faschisten
                    im Dienst der deutschen Industrie» karikiert.
                  </p>
                </TextWidth>
                {/* <TextWidthExtended>
                  <Img src={require('../../images/kommunisten_detail.jpg')} />
                </TextWidthExtended>
                <TextWidth>
                  <Title>
                    «Versteht es, seine Zuhörer zu begeistern»: Hitler war bei
                    den Schweizer Behörden als «wirklicher Volksredner» bekannt.
                  </Title>
                  <Source >Quelle: Schweizerisches Bundesarchiv</Source>
                </TextWidth> */}
              </>
            }
          />
        </>
      )}
      {(part === '2' || debug) && (
        <>
          <TextWidthExtended>
            <Img src={require('../../images/hegi_detail.jpg')} />
          </TextWidthExtended>
          <TextWidth>
            <Title>
              Hat versprochen auf «jegliche politische Tätigkeit zu verzichten»:
              Konsul Hegi berichtet von Hitlers Reiseplänen.
            </Title>
            <Source>Quelle: Schweizerisches Bundesarchiv</Source>
          </TextWidth>
          <Reveal
            colorMode={colorMode}
            images={[
              require('../../images/hegi_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/hegi_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <TextWidth>
                <h4>
                  Hitler versprach, auf «jegliche politische Tätigkeit» zu
                  verzichten
                </h4>
                <p>
                  Am 25. August 1923 beantragt Hitler auf dem Schweizer
                  Generalkonsulat in München eine Einreiseerlaubnis, die er
                  sofort erhält. Der Konsul Gustav Hegi teilt dem
                  Eidgenössischen Politischen Departement – also dem
                  Aussenministerium – nachträglich mit, der «bekannte Führer der
                  Nationalsozialistischen Partei, Schriftsteller Adolf Hitler»,
                  werde zu «Studienzwecken» in die Schweiz reisen. Hitler habe
                  versprochen, auf «jegliche politische Tätigkeit» zu
                  verzichten. Später wird Hegi vom Chef der Fremdenpolizei
                  Heinrich Rothmund getadelt: Sollte Hitler irgendwann erneut um
                  ein Visum bitten, dürfe das Konsulat dies erst erteilen,
                  nachdem eine «Ermächtigung» aus Bern eingetroffen sei.
                </p>
              </TextWidth>
            }
          />
          <Reveal
            cover
            colorMode={colorMode}
            images={[
              require('../../images/kriegsgefahr_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/kriegsgefahr_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <>
                <TextWidth>
                  <h4>
                    Treffen mit Hitler aus «rein journalistischem Interesse»?
                  </h4>
                  <p>
                    Vermutlich reist Hitler in einem alten, von einem Chauffeur
                    gesteuerten Mercedes von München nach Zürich. Er steigt im
                    Hotel St. Gotthard an der Bahnhofstrasse ab, das damals mit
                    seinen «mässigen Preisen» wirbt.
                  </p>
                  <p>
                    Hier trifft er zunächst sechs bis acht Gönner, von denen er
                    sich Geld für seine Partei erhofft. Die potenziellen
                    Sponsoren stammen aus nationalistischen Kreisen und aus dem
                    Kader der Kreuzwehr, einer paramilitärischen,
                    völkisch-nationalen Gruppierung, die kurz zuvor gegründet
                    wurde. Im Hotel St. Gotthard erscheint auch Hans Oehler,
                    Mitbegründer und Redaktor der «Schweizerischen Monatshefte»,
                    des damaligen Organs des rechtsradikalen Volksbundes für die
                    Unabhängigkeit der Schweiz. Später steht in einem Bericht
                    der Deutschen Gesandtschaft in Bern, Oehler habe aus «rein
                    journalistischem Interesse» am Treffen mit Hitler
                    teilgenommen.
                  </p>
                </TextWidth>
              </>
            }
          />
        </>
      )}
      {(part === '3' || debug) && (
        <>
          <Reveal
            colorMode={colorMode}
            images={[
              require('../../images/geldgeber_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/geldgeber_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <>
                <TextWidth>
                  <p>
                    In einem Bericht der Deutschen Gesandtschaft an das
                    Auswärtige Amt in Berlin heisst es, die Kreuzwehr habe
                    ausser den öffentlich bekannten Satzungen «noch besondere
                    Geheimbestimmungen, die stark antisemitischen Charakter»
                    tragen würden. «Der Münchner Antisemitenführer Adolf Hitler
                    ist denn auch Ende August in Zürich (später auch in Bern)
                    gewesen und hat mit den Organisatoren der Kreuzwehr sowie
                    mit alldeutschen Kreisen Fühlung aufgenommen.»
                  </p>
                </TextWidth>
              </>
            }
          />
          <Reveal
            cover
            colorMode={colorMode}
            images={[
              require('../../images/genf_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/genf_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <>
                <TextWidth>
                  <p>
                    Für Hitlers Aufenthalt in Bern gibt es ausser dem Bericht
                    der Deutschen Gesandtschaft keine Belege. Immerhin ist
                    dieses Dokument aber so wichtig, dass es die Amerikaner nach
                    dem Ende des Zweiten Weltkriegs abfotografieren. Das
                    Original des Berichts gilt heute als verschollen: Als das
                    Politische Archiv des Auswärtigen Amts im Jahr 2000 von Bonn
                    nach Berlin umzog, verschwand es unter ungeklärten Umständen
                    zusammen mit anderen Dokumenten, die bereits auf einer
                    Palette mit einer Stretchfolie umwickelt für den Umzug
                    vorbereitet waren.
                  </p>
                  <p>
                    Hitler ist nicht der erste Nationalsozialist, der zu Beginn
                    der 1920er-Jahre in der Schweiz reiche Gönner sucht. Mehrere
                    Vertreter der NSDAP sind schon im Frühjahr 1923 in die
                    Schweiz gereist. Das Terrain ist vorbereitet, weil seit
                    Winter 1922 Rudolf Hess in Zürich lebt. Der spätere
                    Stellvertreter Hitlers, der bei seiner Tante wohnt, will
                    angeblich an der heutigen ETH studieren. Immatrikuliert ist
                    er am Polytechnikum aber nie. Hess’ Aufgabe ist
                    offensichtlich eine andere: Er soll Kontakte zu
                    völkisch-nationalistischen Kreisen in der Schweiz knüpfen,
                    und er tut dies erfolgreich. Wöchentlich isst Hess in der
                    Villa Schönberg zu Mittag, als Gast von Ulrich Wille junior,
                    genannt Ully – dem Sohn des deutschfreundlichen Generals
                    Ulrich Wille, der während des Ersten Weltkriegs
                    Oberbefehlshaber der Schweizer Armee war. Offensichtlich ist
                    es Hess gelungen, den Sohn des Generals für Hitler zu
                    interessieren. Noch vor dessen Zürich-Reise hat der junge
                    Wille Veranstaltungen der NSDAP in München besucht und
                    Hitler persönlich kennen gelernt.
                  </p>
                </TextWidth>
              </>
            }
          />
        </>
      )}
      {(part === '4' || debug) && (
        <>
          <Reveal
            colorMode={colorMode}
            images={[
              require('../../images/duebendorf_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/duebendorf_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <>
                <TextWidth>
                  {/* <p>
                    In der Schweiz haben sich in der ersten Hälfte der
                    1920er-Jahre die Aktivitäten nationalistischer, völkischer
                    und antisemitischer Kräfte verstärkt. Beflügelt werden sie
                    nicht zuletzt durch den italienischen Diktator Benito
                    Mussolini, dessen faschistische Partei im Oktober 1922 in
                    Rom die Macht ergreift. Laut dem Historiker Hans Ulrich Jost
                    – einer der renommiertesten Experten für linken und rechten
                    Extremismus in der ersten Hälfte des 20. Jahrhunderts in der
                    Schweiz – entsteht hierzulande ein Geflecht aus
                    paramilitärischen Heimwehren, rechten Studentenverbindungen,
                    patriotischen Vereinigungen gegen Ausländer und Kommunisten.
                    «Dem Frontenfrühling, der in der Schweiz in den 1930er
                    Jahren ausbrechen wird, geht zehn Jahre zuvor ein
                    rechtsextremer Vorfrühling voraus», sagt Jost im Gespräch
                    mit dieser Redaktion. Dem Historiker zufolge sind es
                    Dutzende von Gruppierungen, die zwar keine eigentliche
                    Massenbewegung bilden, aber viele Anhänger haben - «gerade
                    in den traditionell deutschlandfreundlichen Kreisen von
                    Unternehmern, Grossbürgern, Akademikern und Militärs.»
                  </p> */}
                  <p>
                    {/* In einem Bericht der Deutschen Gesandtschaft an das
                    Auswärtige Amt in Berlin heisst es, die Kreuzwehr habe
                    ausser den in der Öffentlichkeit bekannten Satzungen «noch
                    besondere Geheimbestimmungen, die stark antisemitischen
                    Charakter» tragen würden. «Der Münchner Antisemitenführer
                    Adolf Hitler ist denn auch Ende August in Zürich (später
                    auch in Bern) gewesen und hat mit den Organisatoren der
                    Kreuzwehr sowie mit alldeutschen Kreisen Fühlung
                    aufgenommen.» */}
                  </p>
                </TextWidth>
              </>
            }
          />
          <Reveal
            cover
            colorMode={colorMode}
            images={[
              require('../../images/stadtpolizei_es' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
              require('../../images/stadtpolizei_ds' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg'),
            ]}
            overlayContent={
              <>
                <TextWidth>
                  <p>
                    Der Historiker Raffael Scheck hat ausgerechnet, dass Hitler
                    zu jener Zeit selbst mit 11’000 Franken 18 seiner höchsten
                    NSDAP-Führer oder 43 Angehörige seiner SA zwischen dem
                    Besuch in der Schweiz und dem Putschversuch, den Hitler am
                    8. November 1923 in München macht, hätte finanzieren können.
                    Für die Nazis, die sich damals keine Zugtickets leisten
                    konnten und Löhne oftmals in Form von Naturalien beglichen,
                    sind die Schweizer Spenden ein bedeutender Beitrag – zumal
                    1923, dem Jahr, in dem eine beispiellose Hyperinflation die
                    Weimarer Republik heimsucht. Laut Raffael Scheck sind die
                    Spenden aus der Schweiz in jenen Monaten gar die wichtigsten
                    Einkünfte der Partei.
                  </p>
                  <p>
                    Zurückgekehrt in die Schweiz ist Hitler nicht mehr.
                    Publizistisch jedoch hatte er später im «Tages-Anzeiger»
                    einen Auftritt. Am 17. Dezember 1931 publiziert die Zeitung
                    auf ihrer Frontseite unter dem Titel «Was wollen wir
                    Nationalsozialisten?» einen Gastbeitrag Hitlers. Darin
                    wiederholt er zentrale Aussagen, die er 1923 bei seinem
                    Auftritt in Zürich im kleinen Kreis vorgetragen hat.
                  </p>
                </TextWidth>
              </>
            }
          />
        </>
      )}
    </AppContainer>
  )
}
const Img = styled.img`
  max-width: 100%;
  margin-top: 30px;
`
const Source = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: var(--gray-3);
  margin-bottom: 60px;
  text-align: left;
  line-height: 21px;
  width: 100%;
`
const Title = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 15px;
  color: var(--text-color);
  text-align: left;
  width: 100%;
  line-height: 21px;
  margin-top: 10px;
`
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  h4 {
    font-family: var(--font-serif);
    font-size: 24px;
    line-height: 27px;
    padding: 0;
    padding-top: 30px;
    margin: 0;
    margin-bottom: 15px;
  }
  @media screen and (max-width: 711px) {
    font-size: 1.7rem;
    line-height: 2.7rem;
  }
`
export default MainComponent
